import type { PrivateEvent } from '../../api/privateEvents';

import PrivateEventCard from './PrivateEventCard';

/**
 * The private-events list on a phone (BON-518).
 *
 * A card per event rather than the six-column table. The table only *appears*
 * to work at 375px — it scrolls sideways inside its card, so headcount,
 * staffing and deal value sit off-screen, and those are precisely what an RD
 * opens this list to check. Every field the table shows is on the card.
 */
export default function PrivateEventsCardList({
  events,
  onOpen,
}: {
  events: PrivateEvent[];
  onOpen?: (event: PrivateEvent) => void;
}) {
  return (
    <ul style={{ display: 'flex', flexDirection: 'column', gap: 10, margin: 0, padding: 0 }}>
      {events.map((event) => (
        <li key={event.id} style={{ listStyle: 'none' }}>
          <PrivateEventCard event={event} onOpen={onOpen} />
        </li>
      ))}
    </ul>
  );
}
